import { AiOutlinePartition } from 'react-icons/ai';
import { GiThermometerScale } from 'react-icons/gi';
import { GrUser } from 'react-icons/gr';
import { HiDocumentReport } from 'react-icons/hi';
import {
  MdDriveFolderUpload,
  MdLocationOn,
  MdOutlineCalendarMonth,
} from 'react-icons/md';
const tiles = [
  {
    sNo: 1,
    link: '/common/company_roles_responsibilities_listOfProcedures?documentType=clause15ListOfProcedure',
    isLink: true,
    icon: <MdDriveFolderUpload size="5rem" color="#003566" />,
    p: 'LIST OF',
    span: 'PROCEDURE',
    isIcon: true,
  },
  // {
  //   sNo: 1,
  //   link: '/common/masterListLocationList',
  //   isLink: true,
  //   icon: <MdLocationOn size="5rem" color="#343a40" />,
  //   p: 'MANAGE',
  //   span: 'LOCATION',
  //   isIcon: true,
  // },
  {
    sNo: 1,
    link: '/common/instrumentsTiles',
    isLink: true,
    icon: <GiThermometerScale size="5rem" color="#343a40" />,
    p: 'Master List of',
    span: 'Instruments',
    isIcon: true,
  },
  {
    sNo: 1,
    link: '/common/tilesCallibrationplan',
    isLink: true,
    icon: <MdOutlineCalendarMonth size="5rem" color="#343a40" />,
    p: 'CALLIBRATION',
    span: 'PLAN',
    isIcon: true,
  },
  {
    sNo: 1,
    link: '/common/tilesMsaplan',
    isLink: true,
    icon: <MdOutlineCalendarMonth size="5rem" color="#343a40" />,
    p: 'MSA',
    span: 'PLAN',
    isIcon: true,
  },
  {
    sNo: 1,
    link: '/common/gaugeRepeatability',
    isLink: true,
    icon: <GiThermometerScale size="5rem" color="#343a40" />,
    p: 'Gauge Repeatability',
    span: 'Data Sheet',
    isIcon: true,
  },
];

export default tiles;
